export const Brands = [
  // dk
  'lendme.dk',
  // fi
  'axolaina.fi',
  'freedomrahoitus.fi',
  'uscore.fi',
  'zmarta.fi',
  // no
  'axofinans.no',
  'centum.no',
  'lendme.no',
  'uloan.no',
  'uscore.no',
  'zmarta.no',
  // se
  'axofinans.se',
  'freedomfinance.se',
  'uscore.se',
  'zmarta.se',
] as const;
export type Brand = (typeof Brands)[number];

export const isBrand = (brand?: string): brand is Brand =>
  Brands.includes(brand as Brand);
